import { useState } from 'react';

import { useMutation } from '@betterment/js-runtime';
import { Box, Button, Text } from '@betterment/samba-react';

import { trackClick } from '../../features/track';
import { urlBuilder } from '../../Shared/urlBuilder';

const ResendInvites: React.FC<{ referralInviteId: string }> = ({ referralInviteId }) => {
  const [hasResentInvite, setResentInvite] = useState('');
  const [patchInvite] = useMutation(urlBuilder.patchPersonalReferralInvites(referralInviteId), {
    method: 'patch',
  });

  const resendInvite = async () => {
    const response = await patchInvite();
    if (!response.errors) {
      setResentInvite('success');
    }
  };

  if (hasResentInvite === 'success') {
    return (
      <Text
        as="p"
        color="text.weak"
        css={{
          marginTop: 'space.50',
          marginBottom: 'space.0',
          fontSize: 'fontSize.50',
        }}
      >
        Invite resent
      </Text>
    );
  }

  return (
    <Box css={{ mt: 'space.50' }}>
      <Button
        variant="textPrimary"
        onClick={() => {
          trackClick({ name: 'ResendInviteLink', module: 'ReferAFriendTreeNode' });
          void resendInvite();
        }}
        aria-label="Resend email invitation"
        title="Resend email invitation"
        data-testid="resend-button"
      >
        Send a reminder
      </Button>
    </Box>
  );
};

export default ResendInvites;
